import React from "react";
import { Route, Routes as RoutesComponent } from "react-router-dom";
import Home from "../pages/Home";
import Clases1 from "../pages/Clases1";
import Clases2 from "../pages/Clases2";
import Login from "../pages/Login";
import Admin from "../pages/Admin";
import Carrito from "../pages/Carrito";
import Alumno from "../pages/Alumno";
import { useAuth } from "../contexts/AuthContext";

const Routes = () => {
  const { currentUser } = useAuth();

  return (
    <RoutesComponent>
      <Route path="/" element={<Home />} />
      <Route path="/clases1" element={<Clases1 />} />
      <Route path="/clases2" element={<Clases2 />} />
      <Route path="/login" element={<Login />} />
      <Route path="/carrito" element={<Carrito />} />
      {currentUser && <Route path="/alumno" element={<Alumno />} />}
      {currentUser && <Route path="/admin" element={<Admin />} />}
    </RoutesComponent>
  );
};

export default Routes;
